import { useEffect, useState } from 'react';

import axios from 'axios';
import MixPanelHelper from 'helpers/mixpanel';
import LogoOlist from 'images/logo-olist';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParam } from 'react-use';
import { termsOfServiceVersion } from 'utils/envs';
import { isEmail } from 'utils/old-ui-commons/validations';

import { Box, Flex, Text } from '@olist/united';

import PreSignupAlerts from '../../components/pre-signup-alerts/pre-signup-alerts';
import PreSignUpForm from '../../components/pre-signup-form/pre-signup-form';
import { API_URLS, MIXPANEL_EVENTS, checkSourceTypeParam } from '../../constants';
import { getLeadTracking } from '../../utils';
import { INITIAL_ALERTS_STATE } from './constants';
import { PreSignupCard, PreSignupWrapper } from './pre-signup-page.style';

const PreSignUpPage = () => {
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState(INITIAL_ALERTS_STATE);
  const emailParam = useSearchParam('email');
  const sourceParam = useSearchParam('source');
  const isValidEmailParam = emailParam && isEmail(emailParam);

  const registerLeadTracking = async (email) => {
    const urlSourceParam = checkSourceTypeParam(sourceParam);
    const leadMarketingTracking = getLeadTracking(urlSourceParam);
    const response = await axios.post(API_URLS.preSignup, {
      ...leadMarketingTracking,
      email,
    });

    // eslint-disable-next-line camelcase
    const leadId = response.data?.lead_id;

    if (leadId) {
      const userData = {
        createdAt: Date.now(),
        email,
        id: leadId,
        lastLogin: null,
        name: null,
        planType: null,
        signupOrigin: 'self-signup',
        termsOfService: termsOfServiceVersion,
      };
      const mixpanelInstance = MixPanelHelper(userData)?.getInstance();
      mixpanelInstance?.track(MIXPANEL_EVENTS.LEAD_INSERTED_EMAIL);
    }
  };

  useEffect(() => {
    if (isValidEmailParam) {
      registerLeadTracking(emailParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line no-unreachable
  return (
    <PreSignupWrapper>
      <Flex flex="1" mx={4} justifyContent="center">
        <Flex alignItems="center" flexDirection="column">
          <Box mt={[4, 8]} mb={[4, 8]}>
            <LogoOlist color="#fff" />
          </Box>
          <PreSignupAlerts {...alerts} />
          <PreSignupCard>
            <Box maxWidth={['400px', '500px']}>
              <Text fontSize={[5, 6]} fontWeight="bold" mb={2} textAlign="center">
                {t(`create your account`)}
              </Text>
              <Text color="foundation.shadeDark" fontSize={[1, 2]} textAlign="center">
                {t(
                  `tell us more about your company and chose the ideal plan to start selling in the principal marketplaces`
                )}
              </Text>
              <PreSignUpForm handleFormError={setAlerts} />
            </Box>
          </PreSignupCard>
          <Text fontSize={0} textAlign="center" color="foundation.shadeWhite" width="70%" my={3}>
            <Trans i18nKey="helpStore">
              have you bought with <b>olist store</b> and need help with the order? access
              <Text.Link
                color="foundation.shadeWhite"
                colorHover="foundation.shadeWhite"
                fontWeight="bold"
                href="https://tracking.olist.com"
              >
                tracking.olist.com
              </Text.Link>
            </Trans>
          </Text>
        </Flex>
      </Flex>
    </PreSignupWrapper>
  );
};

export default PreSignUpPage;
